import renderReactClient from './render-react-client';
import LoginBanner from './components/LoginBanner/LoginBanner';
import LoginForm from './components/LoginForm/LoginForm';
import LoginFormFooter from './components/LoginFormFooter/LoginFormFooter';
import ConfirmEmailAddressForm from './components/ConfirmEmailAddress/ConfirmEmailAddressForm';
import ConfirmPhoneNumberForm from './components/ConfirmPhoneNumber/ConfirmPhoneNumberForm';
import OneTimePasscode from './components/OneTimePasscode/OneTimePasscode';
import ConfirmUsernameForm from './components/ForgotAndResetPassword/ConfirmUsernameForm';
import CreatePasswordForm from './components/CreatePassword/CreatePasswordForm';
import SecurityQuestionsForm from './components/ForgotAndResetPassword/SecurityQuestionsForm';
import ForgotUsernameForm from './components/ForgotUsername/ForgotUsernameForm';
import UpdateUsernameForm from './components/UpdateUsername/UpdateUsernameForm';
import UpdatePasswordForm from './components/UpdatePassword/UpdatePasswordForm';

renderReactClient({
    OneTimePasscode,
    ConfirmUsernameForm,
    CreatePasswordForm,
    ForgotUsernameForm,
    LoginBanner,
    LoginForm,
    LoginFormFooter,
    SecurityQuestionsForm,
    UpdateUsernameForm,
    UpdatePasswordForm,
    ConfirmEmailAddressForm,
    ConfirmPhoneNumberForm
});
